import { MapPin, Phone, MessageCircle, Navigation, Clock } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { LOCATIONS, PHONE_TEL, WHATSAPP_URL, PHONE_DISPLAY } from "../data/content";

export const Locations = () => (
  <section id="locations" className="py-28 sm:py-36 bg-[#F1EDE3]/60 border-t border-[#E3DCCB]/60" data-testid="locations-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>Consultation Locations</Overline>
        <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-stone-800 max-w-3xl leading-snug">
          Two centres. <span className="text-teal-700 italic">One standard — AIIMS-grade care.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {LOCATIONS.map((loc, i) => (
          <Reveal key={loc.name} delay={i * 0.1}>
            <article data-testid={`location-card-${i + 1}`}
              className="h-full p-8 rounded-2xl border border-[#E3DCCB] bg-[#FFFFFF]/60 hover:border-teal-500/40 transition-colors duration-500 flex flex-col">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-serif-display text-2xl font-semibold text-stone-800">{loc.name}</h3>
                  <p className="mt-1.5 text-sm text-teal-700/90">{loc.role}</p>
                </div>
                <MapPin size={22} className="text-teal-700 shrink-0 mt-1" />
              </div>
              <p className="mt-4 text-sm text-stone-500 flex items-center gap-2">
                <span className="font-medium text-stone-600">{loc.city}</span> · {loc.detail}
              </p>
              <p className="mt-3 inline-flex w-fit items-center gap-2 px-4 py-2 rounded-full border border-teal-500/30 bg-teal-500/10 text-teal-700 text-sm font-medium"
                data-testid={`location-timings-${i + 1}`}>
                <Clock size={14} /> {loc.timings}
              </p>
              <div className="mt-8 flex flex-wrap gap-3 pt-6 border-t border-[#E3DCCB]/70">
                <a href={PHONE_TEL} data-testid={`location-call-button-${i + 1}`}
                  className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#0B5A4E] text-[#FAF8F3] text-sm font-semibold hover:bg-[#0D6B5C] transition-colors">
                  <Phone size={14} /> {PHONE_DISPLAY}
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid={`location-whatsapp-button-${i + 1}`}
                  className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#25D366]/50 text-[#25D366] text-sm font-semibold hover:bg-[#25D366]/10 transition-colors">
                  <MessageCircle size={14} /> WhatsApp
                </a>
                <a href={loc.maps} target="_blank" rel="noopener noreferrer" data-testid={`location-directions-${i + 1}`}
                  className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#E3DCCB] text-stone-600 text-sm hover:border-teal-500/40 hover:text-teal-700 transition-colors">
                  <Navigation size={14} /> Directions
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
